import type { IconNode } from '../types';

/**
 * @name crosshair-2-dot
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8Y2lyY2xlIGN4PSIxMiIgY3k9IjEyIiByPSI4IiAvPgogIDxwYXRoIGQ9Ik0xMiA2VjIiIC8+CiAgPHBhdGggZD0iTTIyIDEyaC00IiAvPgogIDxwYXRoIGQ9Ik02IDEySDIiIC8+CiAgPHBhdGggZD0iTTEyIDIydi00IiAvPgogIDxwYXRoIGQ9Ik0xMiAxMmguMDEiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/crosshair-2-dot
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const crosshair2Dot: IconNode = [
  ['circle', { cx: '12', cy: '12', r: '8', key: '46899m' }],
  ['path', { d: 'M12 6V2', key: '1pj48d' }],
  ['path', { d: 'M22 12h-4', key: 'pliqo5' }],
  ['path', { d: 'M6 12H2', key: '17rm5b' }],
  ['path', { d: 'M12 22v-4', key: '1utk9m' }],
  ['path', { d: 'M12 12h.01', key: '1mp3jc' }],
];

export default crosshair2Dot;
